var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopnetLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12000_53840",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12000_53840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0348 12.4122H45.4363C41.209 5.5637 33.6382 1 24.9998 1C11.7453 1 1 11.7453 1 24.9998C1 36.0562 8.47657 45.3645 18.6507 48.1488L28.3194 12.4122H39.0348Z",
    fill: "url(#paint0_linear_12000_53840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0003 25.0006C49.0003 20.3846 47.6949 16.0721 45.4369 12.4131H39.0355H28.3201L18.6514 48.1496C20.6745 48.7029 22.8024 49.0004 25.0005 49.0004C38.2549 49.0004 49.0003 38.2551 49.0003 25.0006Z",
    fill: "url(#paint1_linear_12000_53840)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5166 12.5435C44.6074 11.0497 43.5398 9.66353 42.3376 8.40747C42.0385 8.33868 41.7275 8.2998 41.4075 8.2998H16.3699C14.0985 8.2998 12.2578 10.1405 12.2578 12.4119C12.2578 14.6833 14.0985 16.524 16.3699 16.524H22.4828L17.2716 35.7822C16.6137 38.2136 18.0507 40.7182 20.4835 41.3762C20.8828 41.4838 21.2835 41.5362 21.6768 41.5362C23.6865 41.5362 25.5272 40.1979 26.076 38.1657L31.9317 16.5255H41.409C43.6355 16.5255 45.4478 14.7551 45.5166 12.5435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 47.5387C37.4477 47.5387 47.5387 37.4477 47.5387 24.9998C47.5387 12.5519 37.4477 2.46094 24.9998 2.46094C12.5519 2.46094 2.46094 12.5519 2.46094 24.9998C2.46094 37.4477 12.5519 47.5387 24.9998 47.5387Z",
    fill: "url(#paint2_radial_12000_53840)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12000_53840",
    x1: 17.9286,
    y1: -0.937405,
    x2: 29.2847,
    y2: 44.4365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3618,
    stopColor: "#292D6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4537,
    stopColor: "#2B3671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#2F4F7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7971,
    stopColor: "#377891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40AAAA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12000_53840",
    x1: 34.1091,
    y1: 5.35058,
    x2: 33.6936,
    y2: 51.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "#EA442A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5883,
    stopColor: "#F59326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8077,
    stopColor: "#FCC424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9158,
    stopColor: "#FFD723"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12000_53840",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(27.2122 -26.9517 16.2737 16.4345 6.55947 4.68898)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2791,
    stopColor: "white",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9158,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopnetLogo);
export default __webpack_public_path__ + "static/media/topnetLogo.c870697e6551ccb2946b89992e324cdf.svg";
export { ForwardRef as ReactComponent };